var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FORM_FIELD_TOKENS, WIZARD_COLORS } from '../../FormComponents/dynamicForm';
var START_APPLICATION_TOKENS = {
    selectedColor: WIZARD_COLORS.brand,
    selectedSurface: '#F5F7FF',
    tileSurface: WIZARD_COLORS.page,
    iconSurface: '#B9BEC6',
    headingColor: WIZARD_COLORS.ink,
    mutedColor: WIZARD_COLORS.muted,
};
export var DIALOG_PAPER_SX = { borderRadius: '14px', maxWidth: 660 };
export var DIALOG_CONTENT_SX = { padding: { xs: '20px', sm: '26px 28px 8px' } };
export var DIALOG_ACTIONS_SX = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: { xs: '16px 20px 20px', sm: '16px 28px 26px' },
};
export var DIALOG_TITLE_SX = {
    fontSize: 20,
    fontWeight: 700,
    color: START_APPLICATION_TOKENS.headingColor,
    mb: 2,
};
export var SECTION_LABEL_SX = {
    fontSize: 15,
    color: START_APPLICATION_TOKENS.mutedColor,
};
export var SPACED_SECTION_LABEL_SX = __assign(__assign({}, SECTION_LABEL_SX), { mt: 2.5 });
export var SECTION_DIVIDER_SX = { mt: 1.25, mb: 2 };
export var LOOKUP_ERROR_SX = { mb: 2, fontSize: 13 };
export var TILE_TITLE_SX = {
    fontSize: 15,
    fontWeight: 700,
    color: START_APPLICATION_TOKENS.headingColor,
};
export var TILE_DESCRIPTION_SX = {
    fontSize: 13,
    color: START_APPLICATION_TOKENS.mutedColor,
};
export var TILE_BODY_SX = { flex: 1, minWidth: 0 };
export var TILE_RADIO_SX = {
    color: WIZARD_COLORS.pending,
    '&.Mui-checked': { color: START_APPLICATION_TOKENS.selectedColor },
};
export var applicationTypeTileSx = function (isSelected) { return ({
    display: 'flex',
    alignItems: 'center',
    gap: 1.75,
    width: '100%',
    textAlign: 'left',
    padding: '12px 14px',
    mb: 1.25,
    borderRadius: '10px',
    backgroundColor: isSelected
        ? START_APPLICATION_TOKENS.selectedSurface
        : START_APPLICATION_TOKENS.tileSurface,
    border: "1px solid ".concat(isSelected ? START_APPLICATION_TOKENS.selectedColor : 'transparent'),
}); };
export var applicationTypeIconSx = function (isSelected) { return ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: '10px',
    color: WIZARD_COLORS.surface,
    backgroundColor: isSelected
        ? START_APPLICATION_TOKENS.selectedColor
        : START_APPLICATION_TOKENS.iconSurface,
    '& svg': { fontSize: 22 },
}); };
export var LOOKUP_MENU_ITEM_SX = { fontSize: 14 };
export var LOOKUP_LOADER_SX = { mr: 3, color: FORM_FIELD_TOKENS.labelColor };
export var LOOKUP_REQUIRED_MARK_SX = { color: FORM_FIELD_TOKENS.errorColor };
export var LOOKUP_OPTIONAL_MARK_SX = {
    color: START_APPLICATION_TOKENS.mutedColor,
    fontWeight: 400,
};
export var LOOKUP_SELECT_PROPS = {
    MenuProps: { PaperProps: { style: { maxHeight: 260 } } },
};
export var DEALER_ENTRY_SX = {
    mb: 2,
    pb: 2,
    borderBottom: "1px dashed ".concat(WIZARD_COLORS.pending),
    '&:last-of-type': { borderBottom: 'none', pb: 0 },
};
export var ADD_ANOTHER_DEALER_BUTTON_SX = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    mt: 0.5,
    mb: 2.5,
    padding: 0,
    fontSize: 13,
    fontWeight: 700,
    color: START_APPLICATION_TOKENS.selectedColor,
    textTransform: 'none',
    '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
};
export var REMOVE_DEALER_ENTRY_BUTTON_SX = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    mt: 0.75,
    padding: 0,
    fontSize: 13,
    fontWeight: 700,
    color: START_APPLICATION_TOKENS.mutedColor,
    textTransform: 'none',
    '&:hover': { backgroundColor: 'transparent', color: FORM_FIELD_TOKENS.errorColor, textDecoration: 'underline' },
};
